module.exports = __webpack_public_path__ + "img/bg_icon_5.e3b176e2.svg";